import { gql } from 'apollo-boost'

export default gql`
  fragment filesStatusSummary on FilesStatusSummary {
    count
    status
  }
`
